export class Lookup {
  public lookupId: number;
  public type: string;
  public name: string;
  public displayText: string;
  public value: string;
  public parentId?: number;
  public displayOrder?: number;
  public isActive: boolean;
}
